function isEmpty(value) {
  return value === "" || value === null || value === undefined;
}

function validateDecimal(value, fieldName) {
  if (isEmpty(value)) {
    return `${fieldName} es obligatoria.`;
  }

  if (Number.isNaN(Number(value))) {
    return `${fieldName} debe ser un numero decimal valido.`;
  }

  if (Number(value) < 0) {
    return `${fieldName} no puede ser negativa.`;
  }

  return null;
}

export function validateTarifaGlobalEnterprisePayload({
  priceBase,
  priceDistance,
  priceDuration,
  priceDelay,
}) {
  return (
    validateDecimal(priceBase, "El precio base") ||
    validateDecimal(priceDistance, "El precio distancia") ||
    validateDecimal(priceDuration, "El precio duracion") ||
    validateDecimal(priceDelay, "El precio espera")
  );
}
